import React from 'react';
import {Callout, Intent} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {EXECUTION_STATUS} from '../../constants';
import {ResultRunning} from './ResultRunning';

import './Result.scss';

interface ResultProps {
  result: any;
  successElement?: any;
  failedTitle?: string;
  failedDescription?: any;
  canceledTitle?: string;
  canceledDescription?: any;
  onCancelExecution?: (blockUid: string, key: string) => void;
}

const ResultInner = ({
  result,
  successElement: SuccessElement,
  failedTitle,
  failedDescription,
  canceledTitle,
  canceledDescription,
  onCancelExecution,
}: ResultProps) => {
  if (!result) {
    return null;
  }
  let {status, block_uid, key} = result;

  const _onCancelExecution = () => {
    onCancelExecution && onCancelExecution(block_uid, key);
  }

  switch (status) {
    case EXECUTION_STATUS.SUCCESS:
      return SuccessElement || null;
    case EXECUTION_STATUS.FAILED:
      return (
        failedTitle ? (
          <Callout
            title={failedTitle}
            icon={IconNames.ERROR}
            intent={Intent.DANGER}
            className="content-result__failed"
          >
            {failedDescription || null}
          </Callout>
        ) : null
      );
    case EXECUTION_STATUS.RUNNING:
      return <ResultRunning
        result={result}
        onCancelExecution={onCancelExecution ? _onCancelExecution : undefined}
        key="running"
      />
    case EXECUTION_STATUS.PENDING:
      return <ResultRunning result={result} pending={true} key="pending"/>
    case EXECUTION_STATUS.CANCELLED:
      return (
        canceledTitle ? (
          <Callout
            title={canceledTitle}
            icon={IconNames.STOP}
            intent={Intent.WARNING}
          >
            {canceledDescription || null}
          </Callout>
        ) : null
      );
    default:
      return (<div>Status '{status}' not supported.</div>)
  }
};

export const Result = ({
  result,
  successElement,
  failedTitle,
  failedDescription,
  canceledTitle,
  canceledDescription,
  onCancelExecution,
}: ResultProps) => {
  if (!result) {
    return null;
  }

  return (
    <div className="content-result">
      <ResultInner
        result={result}
        successElement={successElement}
        failedTitle={failedTitle}
        failedDescription={failedDescription}
        canceledTitle={canceledTitle}
        canceledDescription={canceledDescription}
        onCancelExecution={onCancelExecution}
      />
    </div>
  );
};
